// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-container {
max-height: 85vh;
  overflow-y: auto;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm1lbWJlci1saXN0LmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7QUFDQSxnQkFBZ0I7RUFDZCxnQkFBZ0I7QUFDbEIiLCJmaWxlIjoibWVtYmVyLWxpc3QuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5zY3JvbGwtY29udGFpbmVyIHtcbm1heC1oZWlnaHQ6IDg1dmg7XG4gIG92ZXJmbG93LXk6IGF1dG87XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/component/members/member-list/member-list.component.css"],"names":[],"mappings":"AAAA;AACA,gBAAgB;EACd,gBAAgB;AAClB;;AAEA,4WAA4W","sourcesContent":[".scroll-container {\nmax-height: 85vh;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
